export const moviesData = [
  {
    id: 1,
    title: "پیشتازان فضا",
    image: "https://picsum.photos/300/450",
    year: 2023,
    rating: 4.5,
    genre: "علمی تخیلی",
    description: "یک ماجراجویی فضایی هیجان‌انگیز"
  },
  {
    id: 2,
    title: "شاهزاده ایرانی",
    image: "https://picsum.photos/300/450",
    year: 2022,
    rating: 4.8,
    genre: "ماجراجویی",
    description: "داستان یک شاهزاده ایرانی در جستجوی گنج"
  },
  {
    id: 3,
    title: "شب‌های تهران",
    image: "https://picsum.photos/300/450",
    year: 2023,
    rating: 4.2,
    genre: "درام",
    description: "داستان زندگی در تهران مدرن"
  },
  {
    id: 4,
    title: "کوهستان سحرآمیز",
    image: "https://picsum.photos/300/450",
    year: 2022,
    rating: 4.6,
    genre: "فانتزی",
    description: "ماجراجویی در کوهستان‌های اسرارآمیز"
  }
];

export const tvShowsData = [
  {
    id: 1,
    title: "شهرزاد",
    image: "https://picsum.photos/300/450",
    seasons: 3,
    rating: 4.7,
    genre: "درام",
    description: "داستان زندگی در تهران دهه ۴۰"
  },
  {
    id: 2,
    title: "پایتخت",
    image: "https://picsum.photos/300/450",
    seasons: 6,
    rating: 4.9,
    genre: "کمدی",
    description: "داستان طنز یک خانواده تهرانی"
  },
  {
    id: 3,
    title: "مختارنامه",
    image: "https://picsum.photos/300/450",
    seasons: 2,
    rating: 4.8,
    genre: "تاریخی",
    description: "داستان زندگی مختار ثقفی"
  },
  {
    id: 4,
    title: "شب‌های برره",
    image: "https://picsum.photos/300/450",
    seasons: 2,
    rating: 4.6,
    genre: "کمدی",
    description: "داستان طنز زندگی در یک روستا"
  }
];

export const childrenData = [
  {
    id: 1,
    title: "ماجراهای پینوکیو",
    image: "https://picsum.photos/300/450",
    ageGroup: "3-7",
    rating: 4.5,
    genre: "انیمیشن",
    description: "داستان یک عروسک چوبی که زنده می‌شود"
  },
  {
    id: 2,
    title: "شاهزاده و قورباغه",
    image: "https://picsum.photos/300/450",
    ageGroup: "5-10",
    rating: 4.7,
    genre: "انیمیشن",
    description: "داستان یک شاهزاده که به قورباغه تبدیل می‌شود"
  },
  {
    id: 3,
    title: "ماجراهای آلیس",
    image: "https://picsum.photos/300/450",
    ageGroup: "7-12",
    rating: 4.6,
    genre: "ماجراجویی",
    description: "سفری به سرزمین عجایب"
  },
  {
    id: 4,
    title: "داستان اسباب‌بازی‌ها",
    image: "https://picsum.photos/300/450",
    ageGroup: "4-9",
    rating: 4.8,
    genre: "انیمیشن",
    description: "زندگی پنهانی اسباب‌بازی‌ها"
  }
];

export const moreData = [
  {
    id: 1,
    title: "مستند حیات وحش",
    image: "https://picsum.photos/300/450",
    category: "مستند",
    rating: 4.9,
    description: "مستندی درباره حیات وحش ایران"
  },
  {
    id: 2,
    title: "برنامه آشپزی",
    image: "https://picsum.photos/300/450",
    category: "آشپزی",
    rating: 4.5,
    description: "آموزش آشپزی ایرانی"
  },
  {
    id: 3,
    title: "مسابقه استعدادیابی",
    image: "https://picsum.photos/300/450",
    category: "مسابقه",
    rating: 4.7,
    description: "مسابقه استعدادیابی موسیقی"
  },
  {
    id: 4,
    title: "برنامه ورزشی",
    image: "https://picsum.photos/300/450",
    category: "ورزشی",
    rating: 4.6,
    description: "پوشش رویدادهای ورزشی"
  }
]; 